import { memo } from 'react';
import IframeResizer from 'iframe-resizer-react';

import { TYRES_MFE } from './microfrontendsConfig';

type TyresMfeProps = {
    assetId: string;
};

export const TyresMfe = memo(({ assetId }: TyresMfeProps) => {
    return (
        <IframeResizer
            src={TYRES_MFE.url(assetId)}
            checkOrigin={false}
            style={{
                width: '1px',
                minWidth: '100%',
                border: '0',
            }}
        />
    );
});
